import { type DynamicPageSectionName, type SectionMap } from '~/types/template';

export const showPageSections = (sections: Pick<SectionMap, DynamicPageSectionName>) => {
  return {
    showBottom: !!sections.bottom,
    showCenterBottom: !!sections.centerBottom,
    showCenterTop: !!sections.centerTop,
    showRight: !!sections.right,
    showTop: !!sections.top,
  };
};
